import { IRowNode, MenuItemDef } from "ag-grid-community";
import draftLegsStore from "@/store/draftLegsStore";
import { discardDraftLeg } from "@/store/draftLegsStoreACTIONS";
import { IDraftLegRow } from "./cellRenderers/DraftLeg/useDraftLegTicket";

// LQC-2943 - right-click on a draft leg row. Security Details opens under the row (not a
// dropdown), separate from the allocation, so the row is expanded when it opens.
export function returnDraftLegContextMenuItems(
  node: IRowNode,
  row: IDraftLegRow,
): (MenuItemDef | string)[] {
  const isOpen = draftLegsStore.getState().openSecurityDetailIds.includes(row.id);
  return [
    {
      name: isOpen ? "Hide Security Details" : "Show Security Details",
      action: () => {
        draftLegsStore.getState().toggleSecurityDetails(row.id);
        if (!isOpen) node.setExpanded(true);
      },
    },
    {
      // An edit only drops its changes, as the row's ✕ says.
      name: row.edit ? "Discard Changes" : "Discard Leg",
      action: () => discardDraftLeg(row.widgetId, row.id),
    },
    "separator",
    "copy",
  ];
}
